import { Trans } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import { useUniqueArticleHistory } from '@/models/uniqueArticle';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { I18nWording, useDatabaseTranslation } from '@/services/i18n';
import { createBEMClasses } from '@/utils/classname';

import './ActionsSummary.css';

const { block, element } = createBEMClasses('actions-summary');

export const ActionsSummary = () => {
  const { article } = useArticleContext();
  const { data: uniqueArticleHistory } = useUniqueArticleHistory(article.uniqueArticle?.id);

  return (
    <div className={block()}>
      {!uniqueArticleHistory?.actionsSummary.length ? (
        <InlineText size="200" color="secondary">
          <Trans id="requests.new.articles.drawer.history.actions-summary.no-actions">
            No actions to display
          </Trans>
        </InlineText>
      ) : (
        <Box padding="0">
          <>
            {uniqueArticleHistory.actionsSummary.map((actionSummary, key) => (
              <ActionSummaryLine key={key} actionSummary={actionSummary} />
            ))}
          </>
        </Box>
      )}
    </div>
  );
};

const ActionSummaryLine = ({
  actionSummary,
}: {
  actionSummary: { name: I18nWording; quantity: number };
}) => {
  const { _db } = useDatabaseTranslation();

  return (
    <Stack row gap="0.75rem" padding="0.5rem 0.75rem" className={element('action-summary-line')}>
      <InlineText flex={1} style={{ overflow: 'auto', overflowWrap: 'break-word' }}>
        {_db(actionSummary.name)}
      </InlineText>
      <InlineText weight="medium">{actionSummary.quantity}</InlineText>
    </Stack>
  );
};
